<template>
  <div>
    <AppLoader v-if="isLoading" class="text-center" small />
    <b-container fluid>
      <b-navbar toggleable="lg" type="dark" variant="light">
        <b-navbar-brand href="#" class="text-dark">
          <strong>Control Group Searches</strong>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                variant="outline-primary"
                size="sm"
                @click="showAddControlGroupSearchesModal"
                class="mx-2"
              >
                <font-awesome-icon icon="plus" />
              </b-button>

              <b-button class="mr-2" variant="outline-info" size="sm" @click="reloadTable">
                <font-awesome-icon icon="sync" />
              </b-button>
              <b-form-group>
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <b-table
        class="mx-1"
        bordered
        sticky-header="calc(100vh - 200px)"
        ref="table"
        id="control-group-searches-table"
        :busy.sync="isLoading"
        :items="getControlGroupSearchTableData"
        :fields="tableFields"
        :filter="filter"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        responsive="sm"
      >
        <template
          v-slot:cell(control_group_search_created_at)="data"
        >{{age(data.item.control_group_search_created_at)}}</template>

        <template v-slot:cell(status)="data">
          <span v-if="data.item.status == 0">
            <b-badge variant="warning">Processing</b-badge>&nbsp;
            <br />
            {{data.item.control_group_search_population_count}}/{{data.item.control_group_population_count}}
          </span>
          <span v-if="data.item.status == 1">
            <b-badge variant="success">Completed</b-badge>&nbsp;
            <p>{{data.item.updated_at}}</p>
          </span>
        </template>
        <template v-slot:cell(actions)="data">
          <b-button
            size="sm"
            variant="outline-primary"
            :to="'/pri-searches-control-group/'+data.item.control_group_search_id"
          >
            <font-awesome-icon icon="eye"></font-awesome-icon>
          </b-button>
        </template>
      </b-table>
      <b-row>
        <b-col cols="2">
          <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
        </b-col>
        <b-col>
          <b-pagination
            class="float-right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            first-text="First"
            prev-text="Prev"
            next-text="Next"
            last-text="Last"
            aria-controls="control-group-searches-table"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-container>
    <AddPriSimulationControlGroupModel />
  </div>
</template>

<script>
import { HTTP } from "../utils/HTTP";
import AppLoader from "../components/Loader/Loader";
import moment from "moment";
import "moment/locale/es";
import { EventBus } from "@/event-bus.js";
import AddPriSimulationControlGroupModel from "../components/Pri/priSimulationControlGroup/addPriSimulationControlGroupModel.vue";

export default {
  name: "PriSearchesControlGroupContainer",
  components: {
    AppLoader,
    AddPriSimulationControlGroupModel,
  },
  data() {
    return {
      isLoadingPri: false,
      isLoading: false,
      filter: null,
      perPage: 50,
      totalRows: 0,
      currentPage: 1,
      sortBy: "control_group_search_created_at",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      tableFields: [
        {
          key: "control_group_search_created_at",
          label: "Age",
          sortable: true,
        },
        { key: "created_by_user", label: "Created By", sortable: false },
        { key: "title", label: "Control Group", sortable: true },
        { key: "pri_title", label: "PRI", sortable: true },
        {
          key: "control_group_population_count",
          label: "Number of subjects",
          sortable: false,
        },
        { key: "status", label: "Status", sortable: true },
        { key: "actions", label: "Action", sortable: false },
      ],
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  mounted() {},
  methods: {
    showAddControlGroupSearchesModal() {
      EventBus.$emit("onShowAddControlGroupSearchesModal", "");
    },
    age(value) {
      moment.locale("en");

      return moment.utc(value).fromNow();
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "control-group-searches-table");
    },
    async getControlGroupSearchTableData() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
        company_id: this.$route.params.id,
      };

      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP(
        "post",
        "v1/control-group/get-control-group-search-table",
        formData,
        {
          Authorization: token,
        }
      );

      return result
        .then((response) => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        })
        .catch((error) => {
          this.isLoading = false;
          return [error];
        });
    },
  },
};
</script>

<style scoped>
</style>
